// extracted by mini-css-extract-plugin
var _1 = "Segmented_active__da433";
var _2 = "Segmented_disabled__71692";
var _3 = "Segmented_divider__7b707";
var _4 = "Segmented_fluid__0297b";
var _5 = "Segmented_input__ed615";
var _6 = "Segmented_item__a71e0";
var _7 = "Segmented_label__0a019";
var _8 = "Segmented_large__6cc05";
var _9 = "Segmented_medium__07121";
var _a = "Segmented_mini__c5127";
var _b = "Segmented_option__0aa52";
var _c = "Segmented_root__708a4";
var _d = "Segmented_xlarge__c1b54";
var _e = "Segmented_xmini__f9257";
export { _1 as "active", _2 as "disabled", _3 as "divider", _4 as "fluid", _5 as "input", _6 as "item", _7 as "label", _8 as "large", _9 as "medium", _a as "mini", _b as "option", _c as "root", _d as "xlarge", _e as "xmini" }
